import { getFromLocalStorage } from '../utils/storage';

export const getAuthorizationTokenFromLS = () => {
  return getFromLocalStorage('progConnectAuthToken');
};
